var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:{dimmed: _vm.isBeforePush}},[(_vm.isBeforePush)?[_vm._v(_vm._s(_vm.$utils.timeText(_vm.newsData.reserveDate)))]:[_vm._v(_vm._s(_vm.$utils.timeText(_vm.newsData.pushFirstDate)))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }